/**
 * Echo exposes an expressive API for subscribing to channels and listening
 * for events that are broadcast by Laravel. Echo and event broadcasting
 * allows your team to easily build robust real-time web applications.
 */

import store from "./store";
import { setBaseUrl } from "./packages/MyAxios";
import { Config } from "./store/modules/Config.module";
import { types as authType } from "@/store/modules/Auth.module";

store.watch((state) => state.ConfigModule.request.baseUrl, (path) => {
    setBaseUrl(path);
});
store.watch((state) => state.AuthModule.user, (user) => {
    const role = store.getters.rolesConfig.roles.find(role => role.id === user.role);
    const rule = store.getters.rolesConfig.rules[role.rule];
    if (rule.route) {
        Config("routes.default", rule.route);
    }
    if (rule.baseUrl) {
        Config("request.baseUrl", rule.baseUrl);
    }
});

// store.dispatch(authType.GET);

// import Echo from 'laravel-echo';

// window.Pusher = require('pusher-js');

// window.Echo = new Echo({
//     broadcaster: 'pusher',
//     key: process.env.MIX_PUSHER_APP_KEY,
//     cluster: process.env.MIX_PUSHER_APP_CLUSTER,
//     forceTLS: true
// });
